import { useCallback, useEffect, useState } from 'react'

export const useLocalStorageBool = (key: string) => {
  const [isTrue, setIsTrue] = useState(localStorage.getItem(key) === 'true')

  // Edge case if key changes
  useEffect(() => {
    setIsTrue(localStorage.getItem(key) === 'true')
  }, [key])

  const setTrue = useCallback(() => {
    localStorage.setItem(key, 'true')
    setIsTrue(true)
  }, [key])

  const setFalse = useCallback(() => {
    localStorage.setItem(key, 'false')
    setIsTrue(false)
  }, [key])

  return { isTrue, setTrue, setFalse }
}
